import {NgModule} from '@angular/core';
import {AsistenciaCodigoPipe} from '../asistencia/_pipes/asistencia-codigo.pipe';
import { FiltroIDPipe } from '../asistencia/_pipes/filtro-id.pipe';
import { TiposAsistenciaPipe } from '../asistencia/_pipes/tipos-asistencia.pipe';
import { CursoLabelPipe } from './curso-label.pipe';

@NgModule({
    imports: [],
    exports: [
        AsistenciaCodigoPipe,
        CursoLabelPipe,
        TiposAsistenciaPipe,
        FiltroIDPipe
    ],
    declarations: [
        AsistenciaCodigoPipe,
        CursoLabelPipe,
        TiposAsistenciaPipe,
        FiltroIDPipe
    ],
    providers: [],
})
export class GLMAppPipesModule {
  static forRoot() {
    return {
        ngModule: GLMAppPipesModule,
        providers: [],
    };
 }
}
